<template>
  <popup
    :fullscreen="false"
    @updateClosePopup="onCloseDialog"
    @updateSave="onSave"
    height-head="40px"
    width="810"
    title="Send customer dispatch reports"
    btn-text="Send"
    :is-btn-safe="!selected.length"
  >
    <dispatch-reports-table
      v-if="dispatchCustomers"
      :list-items="dispatchCustomers"
      :indeterminate="indeterminate"
      :checkAll="checkAll"
      :valid="$v"
      @updateCheckOrder="onCheckOrder($event, 'dispatchCustomers', 'customer_id')"
      @updateCheckOrders="onCheckOrders($event, 'dispatchCustomers', 'customer_id')"
    ></dispatch-reports-table>
  </popup>
</template>

<script>
// vuex
import { mapActions } from "vuex";
// components
import DispatchReportsTable from "@/components/Statistics/DispatchStatistics/DispatchreportsTable/DispatchReportsTable";
// shared
import Popup from "@/shared/Popup/Popup";
// mixins
import checkBoxOrders from "@/mixins/checkBoxOrders";
// validate
import { email, required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

export default {
	name: "DispatchStatisticsReports",
	mixins: [ checkBoxOrders, validationMixin ],
	components: { DispatchReportsTable, Popup },
	props: {
		dispatchCustomers: Array,
	},
	validations: {
		dispatchCustomers: {
			$each: {
				email: { required, email },
			}
		}
	},
	methods: {
		...mapActions([ 'onSendReports', 'actionPreloader', 'setAlert' ]),
		onCloseDialog() {
			this.$emit("updateDispatchReportsClose");
		},
		async onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				this.actionPreloader(true);
				const { status } = await this.onSendReports({ customers: this.selected });
				this.actionPreloader(false);
				this.setAlert({ type: "success", message: "Report sent successfully" });
				if (status) this.onCloseDialog();
			} else {
				this.setAlert({ type: "error", message: "Need to fill in the fields" });
			}
		}
	}
};
</script>

<style scoped lang="scss"></style>
